<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div class="print-for" v-bind:key="item.EntpCusOId" v-for="item in printList">
                <div class="print-title-view">
                    <div class="order-code">
                        <!-- <svg id="barcode" /> -->
                        <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    </div>

                    <div class="print-title">销售出库单</div>

                    <div class="order-detail">
                        <div class="right">单号：{{ item.OrderCode }}</div>
                        <div class="right">
                            日期：
                            <el-date-picker
                                v-show="isEditOpenTime"
                                v-model="item.CreateTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                size="small"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                            <span v-show="!isEditOpenTime">{{ item.CreateTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">客户名称</div>
                        <div class="div-table-cell fdzt" style="width: 80%">
                            {{ item.EntpCusName }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">客户地址</div>
                        <div class="div-table-cell" style="width: 80%">
                            {{ item.FullAddress }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">序号</div>
                        <div class="div-table-cell" style="width: 18%">汽配编码</div>
                        <div class="div-table-cell" style="width: 16%">配件名称</div>
                        <div class="div-table-cell" style="width: 20%">车型</div>
                        <div class="div-table-cell" style="width: 10%">已出数量</div>
                        <div class="div-table-cell" style="width: 10%">单位</div>
                        <div class="div-table-cell" style="width: 10%">销售单价</div>
                        <div class="div-table-cell" style="width: 15%">销售总价</div>
                        <!-- <div class="div-table-cell" style="width: 13%">仓位</div> -->
                    </div>
                    <div class="div-table-row" v-bind:key="index" v-for="(AP, index) in item.DetailList">
                        <div class="div-table-cell" style="width: 6%">
                            {{ Number(index) + 1 }}
                            <!-- {{ AP.SortNum == 0 ? Number(index) + 1 : AP.SortNum }} -->
                        </div>
                        <div class="div-table-cell" style="width: 18%">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 16%">
                            {{ AP.GoodName }}
                        </div>
                        <div class="div-table-cell" style="width: 20%">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell fdzt" style="width: 10%">
                            {{ AP.Count }}
                        </div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.Price }}</div>
                        <div class="div-table-cell fdzt" style="width: 15%">
                            {{ (AP.Count * AP.Price).toFixed(2) }}
                        </div>
                        <!-- <div class="div-table-cell fdzt" style="width: 13%">
              {{ AP.GoodsLocation }}
            </div> -->
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 18%"></div>
                        <div class="div-table-cell" style="width: 16%"></div>
                        <div class="div-table-cell pall-count" style="width: 20%">总数量 &nbsp;</div>
                        <div class="div-table-cell" style="width: 10%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell pall-count" style="width: 10%">总价 &nbsp;</div>
                        <div class="div-table-cell" style="width: 15%">
                            {{ (allPrice + item.ShipAmount).toFixed(2) }}
                        </div>
                        <!-- <div class="div-table-cell" style="width: 13%"></div> -->
                    </div>
                </div>
                <el-row type="flex" class="order-remark">
                    <el-col :span="4">运费：{{ item.ShipAmount }}</el-col>
                    <el-col :span="6">支付方式：{{ item.PayTypeName }}</el-col>
                    <el-col :span="6">发货方式：{{ item.ShipTypeName }}</el-col>
                    <el-col :span="4"> 业务员：{{ nameConfig ? (item.SNickName ? item.SNickName : item.SName) : item.SName }}</el-col>
                    <el-col :span="4">备货员：</el-col>
                </el-row>
                <el-row type="flex" class="order-remark" v-if="item.DiscountAmount || amountConfig">
                    <el-col v-if="item.DiscountAmount" :span="6">优惠金额：{{ item.DiscountAmount }}</el-col>
                    <el-col v-if="item.DiscountAmount" :span="6">应付总额：{{ (allPrice - item.DiscountAmount).toFixed(2) }}</el-col>
                    <el-col v-if="amountConfig" :span="12">金额总计（大写）：{{ capitalAmount }}</el-col>
                </el-row>
                <el-row type="flex" class="order-remark" v-if="item.Remark">
                    <el-col :span="24">备注：{{ item.Remark }}</el-col>
                </el-row>
                <!--    脚注    -->
                <div class="order-remark" v-if="config == null ? false : config.Result && !isEditConfig">
                    {{ config.RValue }}
                </div>
                <div class="order-setcontent" v-if="isEditConfig">
                    <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig">编辑脚注</el-button>
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime">设置开单时间</el-button>
                    <el-button class="btn-primary" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
            </div>
            <div v-if="printType == 1" class="re-submit">
                <el-button class="btn-primary" v-print="'#printContent'" @click="returnOrderList(true)">打印并返回列表</el-button>
                <el-button class="btn-primary" v-print="'#printContent'" @click="continueToOrder()">打印并继续开单</el-button>
                <el-button @click="returnOrderList(false)">返回列表</el-button>
            </div>
            <div v-else class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: ['printId', 'printType', 'recordIds'],
    data() {
        return {
            listItemWidth: {
                width: '16.6%'
            },
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            permission: {},
            isEditTitle: false, //编辑标题
            titleConfig: {}, //标题配置
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            nameConfig: false,
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            capitalAmount: '',
            amountConfig: false,
            imgUrl: '',
            type: 0,
            loading: false,
            isPreview:false,
            isDefaultSet:false
        };
    },
    watch: {
        printList(value) {
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value[0].OrderCode,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    mounted() {
        if (this.printType) this.type = +this.printType;
        this.permission = this.$util.getPermission('salesOrder');
        this.getSaleOrder();
        this.getConfigByCodes();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyxssj', 'dyxs', 'dyywync', 'dydxje','syllqdysz','dyyl'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyxssj':
                                this.openTimeConfig = data[i];
                                break;
                            case 'dyxs':
                                this.config = data[i];
                                break;
                            case 'dyywync':
                                this.nameConfig = result;
                                break;
                            case 'dydxje':
                                this.amountConfig = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                        }
                    }
                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                        .el-row {
                            margin-bottom: 0;
                        }
                        .print-title-view {
                            width: 762px;
                            position: relative;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;
                            padding: 12px 0;
                        }
                        .order-code {
                            width: 80px;
                            height: 80px;
                            display: inline-block;
                            vertical-align: top;
                            margin-left:10px;
                        }

                        .qrcode-canvas,.qrcode-image{
                            display:none;
                        }
                        .order-detail {
                            color: #000;
                        }
                        .bold{
                            font-weight: bold;
                        }
                        .order-remark {
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-left: 10px;
                            margin-right: 10px;
                            padding-top: 10px;
                            color: #000;
                        }
                        .order-setcontent {
                            padding: 0px 0px 15px 0px;
                            color: #000;
                        }
                        .print-title {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            max-width: 50%;
                            margin: 0 auto;
                            text-align: center;
                            font-size: 20px;
                            font-weight: bold;
                            color: #000;
                            min-height: 26px;
                        }
                        .dialog-footer {
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 20px;
                        }

                        .print-zone {
                            width: 200mm;
                        }

                        .print-table-main {
                            width: 762px;
                            font-size: 12px;
                        }
                        .div-table-cell {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            height: auto;
                            line-height: 30px;
                            padding-left: 10px;
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-bottom: 1px solid #000;
                            color: #000;
                        }
                        .div-table-row {
                            display: flex;
                            border-left: 1px solid #000;
                            margin: 0;
                            font-size: 14px;
                        }
                        .pall-count {
                            text-align: right;
                            padding-right:20px;
                        }
                        .fdzt {
                            font-size: 14px;
                        }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';

                LODOP.ADD_PRINT_BARCODE(10, 1, 100, 100, 'QRCode', this.printList[0].OrderCode);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');

                let contentHeight = document.getElementById('printContent').clientHeight;
                if (contentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '98%', strPrintHtml);
                    LODOP.NEWPAGE();
                }
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({
                        OrderId: this.printId,
                        Type: 7
                    },true
                )
                .then(res => {
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getSaleOrder() {
            this.loading = true;
            if (this.type === 0)
                this.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetEntpCusSaleOrderOutPrint',
                        data: {
                            EntpCusOId: this.printId
                        }
                    })
                    .then(res => {
                        let _allNum = 0;
                        let _allPrice = 0;
                        let data = res.data;
                        let DetailList = data.DetailList;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allPrice += DetailList[i].Count * DetailList[i].Price;
                        }
                        this.allNum = _allNum;
                        this.allPrice = _allPrice;
                        this.printList.push(res.data);
                        let total = (_allPrice + Number(data.ShipAmount) - Number(data.DiscountAmount)).toFixed(2);
                        if (total > 0) {
                            this.capitalAmount = this.$util.moneyToCapital(total);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            else
                this.$util
                    .axiosPost({
                        url: '/api/EntpSaleOrder/PEntpCusSaleOrderOutPrint',
                        data: {
                            OrderId: this.printId,
                            RecordIds: this.recordIds
                        }
                    })
                    .then(res => {
                        let _allNum = 0;
                        let _allPrice = 0;
                        let data = res.data;
                        let DetailList = data.DetailList;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allPrice += DetailList[i].Count * DetailList[i].Price;
                        }
                        this.allNum = _allNum;
                        this.allPrice = _allPrice;
                        this.printList.push(res.data);
                        let total = (_allPrice + Number(data.ShipAmount) - Number(data.DiscountAmount)).toFixed(2);
                        if (total > 0) {
                            this.capitalAmount = this.$util.moneyToCapital(total);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        }
    }
};
</script>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 10px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
    .pall-count {
        text-align: right;
    }
}
.btn-ctn-left {
    display: flex;
}
.fullCut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fdzt {
    font-size: 14px;
}
</style>
